// config.js

const bizIcon = "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg";
const imageOne = "https://media.istockphoto.com/id/1465680787/photo/aerial-trent-severn-waterway-lock-18-hastings-and-trent-river-hastings-canada.jpg?s=612x612&w=0&k=20&c=I9w5K_cIRcB-1VTccBCNsMJpD4sX8CrgSsZ-8fjUh3Y=";
const imageTwo = "https://media.istockphoto.com/id/1000394772/photo/an-aerial-view-on-harpers-ferry-historic-town-and-park-west-virginia-usa.jpg?s=612x612&w=0&k=20&c=D1oH7mTRqa7QEKb8qdhkAYISyiX_1_uXY1noXDVj9Zg=";
const imageThree = "https://media.istockphoto.com/id/1349049319/photo/fall-in-ashfield.jpg?s=612x612&w=0&k=20&c=bdAxT8FNshZxherGMcp9B6Xhd9GRBl_cVDoHVM4OH0U=";
const imageFour = "https://media.istockphoto.com/id/1145563084/photo/row-of-old-brick-detached-houses-with-gables-and-large-porches.jpg?s=612x612&w=0&k=20&c=wsLV1SPphcPGtgmo2BHbUkydyCjBhKcIiHONBWraYJQ=";
const imageFive = "https://images.marketleader.com/MarketingImages/62/2403862_normal.PNG";

export const siteConfig = {
  title: "Maureen Onder | Coldwell Banker Realty",
  metaDescription: "Maureen Onder | Coldwell Banker Realty",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-500"
  },
  logo: {
    src: bizIcon,
    alt: "Maureen Onder | Coldwell Banker Realty",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Maureen Onder | Coldwell Banker Realty",
    headline: "Your Real Estate Matchmaker in St. Louis",
    address: "2203 South Big Bend Boulevard, St. Louis, MO 63117",
    description: `
      Maureen Onder, a proud partner of Coldwell Banker Realty, is your trusted guide to buying, selling, and investing in St. Louis real estate. With a deep understanding of the local market, unmatched dedication, and a knack for connecting clients with their perfect homes, Maureen delivers a seamless and personalized experience every step of the way.`,
  },  
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Real Estate Expert in St. Louis",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description: 
        "Buying or selling a home is a major decision, and Maureen is dedicated to making the process smooth and stress-free with thoughtful guidance at every step.",
    },
    {
      description: 
        "With a deep knowledge of St. Louis neighborhoods and local market trends, Maureen offers expert advice to help you find the perfect home or maximize the sale of your property.",
    },
    {
      description: 
        "Committed to exceeding expectations, Maureen ensures you feel supported, informed, and confident throughout your real estate journey.",
    },
  ],  
  services: {
    sectionTitle: "Communities Served",
    description: 
      "Maureen Onder is proud to serve the diverse neighborhoods of St. Louis, MO, providing personalized real estate services tailored to each community. Whether you’re a first-time homebuyer, looking to upgrade, or an investor, Maureen combines local market expertise and community insights to help you find the perfect fit.",
    callouts: [
      {
        name: 'Clayton',
        description: 'Known for its vibrant downtown, excellent schools, and upscale living, Clayton is perfect for professionals and families seeking a dynamic yet refined lifestyle.',
        imageSrc: imageTwo,
        imageAlt: 'Clayton neighborhood in St. Louis, MO',
      },
      {
        name: 'Lemay',
        description: 'An elegant community with lush greenery, top-rated schools, and luxurious homes, ideal for those seeking privacy and exclusivity.',
        imageSrc: imageThree,
        imageAlt: 'Lemay neighborhood in St. Louis, MO',
      },
      {
        name: 'Webster Groves',
        description: 'A charming suburb with historic homes, tree-lined streets, and a tight-knit community, offering a mix of tradition and modernity.',
        imageSrc: imageFour,
        imageAlt: 'Webster Groves neighborhood in St. Louis, MO',
      },
    ],
    otherServices: [
      "Saint Charles",
      "Saint Peters",
      "Saint Louis",
    ],
  },
  about: {
    sectionTitle: "About Maureen Onder | Coldwell Banker Realty",
    description: "Maureen Onder brings unparalleled expertise in St. Louis real estate, offering clients personalized service backed by deep market knowledge and a commitment to excellence. Whether you're buying, selling, or investing, Maureen strives to make the process seamless and rewarding, delivering a real estate experience that exceeds expectations.",
    image: {
      src: imageFive,
      alt: "Maureen Onder, trusted St. Louis real estate expert at Coldwell Banker Realty",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "2203 South Big Bend Boulevard, St. Louis, MO 63117",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3090.7410595099176!2d-90.32142088476382!3d38.61704697961601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d8b4b5b4b5b8f1%3A0xa6d7760cf744e1c6!2s2203%20S%20Big%20Bend%20Blvd%2C%20St.%20Louis%2C%20MO%2063117%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=2203%20South%20Big%20Bend%20Boulevard,%20St.%20Louis,%20MO%2063117&ll=38.617047,-90.321421&q=2203%20South%20Big%20Bend%20Boulevard' 
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=2203+South+Big+Bend+Boulevard,+St.+Louis,+MO+63117&FORM=HDRSC6' 
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/2203+South+Big+Bend+Boulevard,+St.+Louis,+MO+63117/@38.617047,-90.321421,15a,814.57589625d,35y,0h,0t,0r' 
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/2203+S+Big+Bend+Blvd,+St.+Louis,+MO+63117/@38.617047,-90.321421,15z' 
      }
    ]
  },  
  contact: {
    sectionTitle: "Ready to Find Your Dream Home?",
    description: "Contact Maureen Onder | Coldwell Banker Realty to discuss your real estate goals or schedule a consultation. Whether you’re buying, selling, or investing in the St. Louis area, Maureen is here to provide expert guidance and personalized support every step of the way.",
    socialLinks: {
      facebook: "https://www.lighthouserealtymo.com/",     
      instagram: "https://www.lighthouserealtymo.com/",     
      twitter: "https://www.lighthouserealtymo.com/",     
      linkedin: "https://www.lighthouserealtymo.com/",     
      youtube: "https://www.lighthouserealtymo.com/",     
    },
    contactNumbers: [
      "Mobile: (314) 503-7076",
    ],
    logo: bizIcon,
    emailRecipient: "monder@cbphomes.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
